export default "__VITE_ASSET__C09rbYGX__"